export function setNewRelicUserId(clientId) {
    const newRelic = window.NREUM || null;
    newRelic?.setUserId?.(clientId || null);
}

export function setNewRelicUserAttributes(store) {
    const newRelic = window.NREUM || null;
    const { email, profileId } = store.state?.profile || {};

    if (profileId) {
        newRelic?.setCustomAttribute?.('profileId', profileId);
    }

    if (email) {
        newRelic?.setCustomAttribute?.('email', email);
    }
}
